import React, { Component, Fragment } from "react";
import { reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import { Col, Button, Row, Container } from "reactstrap";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import EpicrisisPDF from "./EpicrisisPDF";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import EpicrisisList from "./EpicrisisList";
import { reject } from "lodash";

class Epicrisis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      epicrisisList: [],
      epicrisis: "",
      showPDFEpicrisis: false,
      isShowView: true,
      viewEdit: false,
      id_hist_nota_clin: null
      /*  vitalSigns: {
                weight: '',
                height: '',
                imc: '',
                bodySurface: '',
                heartRate: '',
                breathingFrequency: '',
                bloodPressureMM: '',
                bloodPressureHg: ''
            } */
    };
  }

  componentDidMount() {
    this.fetchListEpicrisis();
  }

  /*     loadPhysicalExam = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'fisico/consultar-admision', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_admision: this.props.data.id_admision })
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el Servidor");
                }
            })
            .then(data => {
                if (data.existe) {
                    console.log({ data: data.contenido[0] })
                    this.displayInfoPhysicalExam(data.contenido[0]);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    } 
            
    displayInfoPhysicalExam = (infoVitalSigns) => {
        this.setState({
            vitalSigns: {
                ...this.state.vitalSigns,
                weight: infoVitalSigns.peso,
                height: infoVitalSigns.talla,
                imc: infoVitalSigns.masa_corporal,
                bodySurface: infoVitalSigns.superficie_corporal,
                heartRate: infoVitalSigns.frecuencia_cardiaca,
                breathingFrequency: infoVitalSigns.frecuencia_respiratoria,
                bloodPressureMM: infoVitalSigns.presion_arterial,
                bloodPressureHg: infoVitalSigns.presion_arterial2
            }
        })
    }

    */

  fetchListEpicrisis = async () => {
    this.setState({ isLoading: true });

    fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "notas-clinicas/consultar-por-admision?id_admision=" +
        this.props.data.id_admision +
        "&tipo_nota=E",
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el servidor");
        }
      })
      .then((data) => {
        this.setState({ epicrisisList: data, isLoading: false });
        if (data.length) {
          this.setState({ isShowView: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ epicrisisList: [], isLoading: false });
      });
  };

  handlerClinicEpicrisis = (epicrisis) => {
    this.setState({ epicrisis: epicrisis });
  };

  handlerEditEpicrisis = async () =>{    
    var dataUpdateNota = {
      id_hist_nota_clin: this.state.id_hist_nota_clin,
      nota_clinica: this.state.epicrisis
    }
    return new Promise((resolve, reject) =>{
      fetch(process.env.REACT_APP_PUBLIC_URL + "notas-clinicas/update",{
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataUpdateNota),
      })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        console.log(data);
        resolve(data);
        this.fetchListEpicrisis();
        this.setState({ epicrisis: "", viewEdit:false, id_hist_nota_clin:"" });
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
    })

  }

  handlerSubmitEpicrisis = async () => {
    let user = JSON.parse(sessionStorage.getItem("usuario"));
    let dataSend = {
      id_admision: this.props.data.id_admision,
      id_historia: this.props.data.id_historia,
      nota_clinica: this.state.epicrisis,
      id_usuario: user.id_usuario,
      fecha: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      tipo_nota: "E",
    };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "notas-clinicas/create", {
      method: "POST",
      headers: {
        authorization: "Bearer " + sessionStorage.getItem("token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          console.log("Epicrisis registrada Correctamente");
          this.setState({ epicrisis: "" });
          this.setState({ isShowView: false });
          this.fetchListEpicrisis();
        } else {
          throw new Error("Ha ocurrido un error en el servidor");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Ha ocurrido un error registrando la epicrisis");
      });
  };

  editEpicrisis = (epicrisis,id_hist_nota_clin ) => {
    this.setState({ viewEdit: true, epicrisis: epicrisis, id_hist_nota_clin: id_hist_nota_clin });
  };

  printClinicEpicrisis = (idEpicrisis) => {
    let profile = JSON.parse(sessionStorage.getItem("clinica"));
    let dataPrint = {
      profile: profile,
      admision: this.props.data.id_admision,
      fecha_admision: this.props.data.fecha,
      patient: {
        typeOfDocument: this.props.data.tip_documento,
        documentNumber: this.props.data.num_documento,
        names: this.props.data.nombres,
        firstLastName: this.props.data.apellido1,
        secondLastName: this.props.data.apellido2,
        gender: this.props.data.sexo,
        city: this.props.data.adress.ciudad,
        address: this.props.data.adress.direccion,
        telephone: this.props.data.telephone,
        cellphone: this.props.data.telephone,
        email: this.props.data.correo,
        civilStatus: this.props.data.e_civil,
        birthday: this.props.data.birthday,
      },
      epicrisisList: this.state.epicrisisList,
      idEpicrisis: idEpicrisis,
      servicios: this.props.data.servicios,
    };

    this.setState({ showPDFEpicrisis: true }, () => {
      EpicrisisPDF(dataPrint);
    });
  };

  render() {
    let reactTableData = {
      tableHeaderData: [
        {
          Header: "Usuario Autor",
          accessor: "nombre_usuario",
          Cell: (row) => <p>{row.value}</p>,
        },
        {
          Header: "Fecha",
          accessor: "fecha",
          Cell: (row) => (
            <p>{moment(row.value).format("YYYY-MM-DD HH:mm:ss")}</p>
          ),
        },
        {
          Header: "Epicrisis",
          accessor: "nota_clinica",
          Cell: (row) => (
            <p
              style={{
                maxHeight: "50px",
                maxHeight: "100px",
                overflowY: "scroll",
                maxWidth: "750px",
              }}
            >
              {row.value}
            </p>
          ),
        },
      ],
      tableRowsData: this.state.epicrisisList,
    };

    return (
      <Fragment>
        <Container>
          <div className={"container-wraper-hc"}>
            <Row>
              <div
                className="form"
                style={{ flex: 1, flexDirection: "column" }}
              >
                <div className="form__form-group">
                  <div className="title-clinic-history">
                    <h4> Epicrisis: </h4>
                  </div>
                  <div
                    className="form__form-group-field"
                    style={{ marginTop: 10 }}
                  >
                    {(this.state.isShowView || this.state.viewEdit) && (
                      <textarea
                        name="textarea-observation-inteview"
                        value={this.state.epicrisis}
                        onChange={(e) => {
                          this.handlerClinicEpicrisis(
                            e.target.value.replace(/(\r\n|\n|\r)/gm, " ")
                          );
                        }}
                      ></textarea>
                    )}
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div className="flex-start-elem">
                {this.state.isShowView && (
                  <div className="flex-end-elem-elemt">
                    <Button
                      style={{ marginTop: 20 }}
                      color="primary"
                      size="sm"
                      onClick={() => {
                        this.handlerSubmitEpicrisis();
                      }}
                    >
                      Agregar Epicrisis
                    </Button>
                  </div>
                )}

                {this.state.viewEdit && (
                  <div className="flex-end-elem-elemt">
                    <Button
                      style={{ marginTop: 5 }}
                      color="primary"
                      size="sm"
                      onClick={() => {
                        this.handlerEditEpicrisis();
                      }}
                    >
                      Editar Epicrisis
                    </Button>
                  </div>
                )}

                {/*   <div className="flex-end-elem-elemt">
                <Button
                  style={{ marginTop: 20 }}
                  color="success"
                  size="sm"
                  onClick={() => {
                    this.printClinicEpicrisis(null);
                  }}
                >
                  Imprimir Todas las Notas
                </Button>
              </div>*/}
              </div>
            </Row>

            {/*  {this.props.userPermits.includes(62) && (
              <Fragment>
                <Row>
                  <div className="title-clinic-history">
                    <h4> Información Examen Físico </h4>
                  </div>
                </Row>
                <Row>
                  <Col md={3}>
                    <h5 className="sub-title">Peso (kg):</h5>{" "}
                    {this.state.vitalSigns.weight}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">Talla (cm):</h5>{" "}
                    {this.state.vitalSigns.height}{" "}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">IMC:</h5>{" "}
                    {this.state.vitalSigns.imc}{" "}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">Superficie corporal (mc):</h5>{" "}
                    {this.state.vitalSigns.bodySurface}
                  </Col>
                </Row>
                <hr style={{ color: "#55e5bb" }}></hr>
                <Row>
                  <Col md={3}>
                    <h5 className="sub-title">Frecuencia Cardiaca (lmp):</h5>
                    {this.state.vitalSigns.heartRate}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">
                      Frecuencia respiratoria (resp/min):
                    </h5>{" "}
                    {this.state.vitalSigns.breathingFrequency}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">Presión Arterial mm:</h5>{" "}
                    {this.state.vitalSigns.bloodPressureMM}
                  </Col>
                  <Col md={3}>
                    <h5 className="sub-title">Presión Arterial Hg:</h5>{" "}
                    {this.state.vitalSigns.bloodPressureHg}
                  </Col>
                </Row>
              </Fragment>
            )} */}

            <Row>
              {this.state.isLoading == true ? (
                <div className="text-center">
                  <Spinner animation="border" variant="success" />
                </div>
              ) : (
                <EpicrisisList
                  reactTableData={reactTableData}
                  Callback={this.fetchListEpicrisis}
                  editEpicrisis={this.editEpicrisis}
                  printClinicEpicrisis={this.printClinicEpicrisis}
                />
              )}
            </Row>

            {this.state.showPDFEpicrisis ? (
              <Modal
                open={this.state.showPDFEpicrisis}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
              >
                <div
                  className="paperAppointment-flex"
                  style={{ width: "100%", margin: 10 }}
                >
                  <IconButton
                    style={{ float: "right" }}
                    onClick={() => {
                      this.setState({ showPDFEpicrisis: false });
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <iframe id="pdfV" width="1000" height="700"></iframe>
                </div>
              </Modal>
            ) : null}
          </div>
        </Container>
      </Fragment>
    );
  }
}

Epicrisis.defaultProps = {
  userPermits: [],
};
export default reduxForm({
  form: `notes-history-form`, // a unique identifier for this form
})(withTranslation("common")(Epicrisis));
